import {
  Document,
  Image,
  Page, Text, View
} from "@react-pdf/renderer";
import email from "../../../../assets/icons/email.png";
import location from "../../../../assets/icons/location.png";
import call from "../../../../assets/icons/phone.png";
import Logo from "../../../../assets/image/logo512.png";
import { formatToDDMMYYYY, toCapitaliseStringType1 } from "../../../../utils/common";
import { reportStyles } from "../../../custom-report/report-style";

const EmployeeExportPDF = ({ employeeExportData, branchList, organizationInfoEmpExport: orgInfo }) => {
  return (
    <Document>
      <Page size="A4" orientation="landscape" style={reportStyles.page}>
        {/* Static-Header */}

        <View style={reportStyles.pdfHeader}>
          <View style={reportStyles.PdfLogo}>
            <Image
              src={orgInfo?.logo ? `${orgInfo.path}${orgInfo.logo}` : Logo}
              alt="Logo"
              style={reportStyles.Logo}
            />
          </View>

          <View style={reportStyles.HeaderDescription}>
            {orgInfo?.org_name && (
              <Text style={reportStyles.HeaderHeading}>{orgInfo?.org_name}</Text>
            )}
            {(orgInfo?.address || orgInfo?.locality || orgInfo?.landmark ||
              orgInfo?.city || orgInfo?.state || orgInfo?.country || orgInfo?.pincode) && (
                <View style={[reportStyles.HeaderLocation, { marginBottom: "10px" }]}>
                  <Image src={location} alt="location" style={{ width: "12px", height: "auto", objectFit: "contain" }} />
                  <Text>
                    {orgInfo?.address ? orgInfo.address + ", " : ""}
                    {orgInfo?.locality ? orgInfo.locality + ", " : ""}
                    {orgInfo?.landmark ? orgInfo.landmark + ", " : ""}
                    {orgInfo?.city ? orgInfo.city + ", " : ""}
                    {orgInfo?.state ? orgInfo.state + ", " : ""}
                    {orgInfo?.country ? orgInfo.country + " " : ""}
                    {orgInfo?.pincode ? orgInfo.pincode : ""}
                  </Text>
                </View>
              )}

            <View style={reportStyles.HeaderLocation}>
              {/* Phone Number */}
              {(orgInfo?.phone || orgInfo?.landline) && (
                <View style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "row" }}>
                  <Image src={call} alt="call" style={{ width: "12px", height: "auto", objectFit: "contain" }} />
                  <Text>{orgInfo?.phone || orgInfo?.landline}</Text>
                </View>
              )}

              {/* Email Address */}
              {orgInfo?.email && (
                <View style={{ display: "flex", alignItems: "center", gap: "5px", flexDirection: "row" }}>
                  <Image src={email} alt="email" style={{ width: "12px", height: "auto", objectFit: "contain" }} />
                  <Text>{orgInfo?.email}</Text>
                </View>
              )}
            </View>
          </View>
        </View>

        {/* Static-Header */}

        {/* <Text style={reportStyles.pdfHeaderTableHeading}>
          Employee Details of March 2025
        </Text> */}
        {/* <View style={reportStyles.pdfHeaderTable}>
          <View style={reportStyles.pdfHeaderBox}>
            <Text>Total Employee:</Text>
            <Text>100</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Salaried Employee:</Text>
            <Text>80</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>New Joining:</Text>
            <Text>5</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Left In Service:</Text>
            <Text>2</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Employee On Leave:</Text>
            <Text>3</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>ESI Member:</Text>
            <Text>60</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Employee Under P-Tax :</Text>
            <Text>50</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Total Male Employee</Text>
            <Text>25</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>EPF Cover Wages:</Text>
            <Text>₹400000.00</Text>
          </View>
          <View style={reportStyles.pdfHeaderBox}>
            <Text>Total Female Employee:</Text>
            <Text>15</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>P-Tax Amount:</Text>
            <Text>₹5000.00</Text>
          </View>

          <View style={reportStyles.pdfHeaderBox}>
            <Text>Others Employee:</Text>
            <Text>4</Text>
          </View>
        </View> */}

        {/* start here  */}

        <View style={reportStyles.ReportTable}>
          <View style={reportStyles.ReportTh}>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                { width: "2%", borderRight: "1px solid #000" },
              ]}
            >
              SL NO
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                { width: "5%", borderRight: "1px solid #000" },
              ]}
            >
              E-CODE
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                { width: "10%", borderRight: "1px solid #000" },
              ]}
            >
              NAME
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Phone No
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Email Id
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "4%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              DOB
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Joining Data
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Gender
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Designation
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Department
            </Text>

            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Qualification
            </Text> */}

            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Employee Type
            </Text>


            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Branch
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Address
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "7%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Guardian Name
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Salary
            </Text>
            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              ESI No
            </Text>

            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              UAN No
            </Text>

            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              CTC
            </Text> */}

            <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Gross
            </Text>

            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                  borderRight: "1px solid #000",
                },
              ]}
            >
              Basic
            </Text> */}

            {/* <Text
              style={[
                reportStyles.ReportHeaderCell,
                {
                  width: "5%",
                  textAlign: "center",
                },
              ]}
            >
              Allowance
            </Text> */}
          </View>
          {employeeExportData.map((data, index) => (
            <>
              <View style={reportStyles.ReportTd}>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    { width: "2%", borderRight: "1px solid #000" },
                  ]}
                >
                  <Text>{index + 1}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      borderRight: "1px solid #000",
                      textAlign: "center",
                    },
                  ]}
                >
                  <Text>
                    {data?.employee_code ? data?.employee_code : "--"}
                  </Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "10%",
                      borderRight: "1px solid #000",
                      textAlign: "center",
                    },
                  ]}
                >
                  <Text>
                    {data?.first_name && data?.last_name
                      ? `${data.first_name} ${data.last_name}`
                      : "--"}
                  </Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text>{data?.phone ? data?.phone : "--"}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text>{data?.email ? data?.email : "--"}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "4%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text>
                    {data?.date_of_birth ? formatToDDMMYYYY(new Date(data?.date_of_birth)) : "--"}
                  </Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text>{data?.join_date ? formatToDDMMYYYY(new Date(data?.join_date)) : "--"}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text> {data?.gender ? data?.gender : "--"}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text> {data?.designation?.designation_name ? data?.designation?.designation_name : "--"}</Text>

                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text> {data?.department?.dept_name ? data?.department?.dept_name : "--"}</Text>
                </View>

                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text>----</Text>
                </View> */}

                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text>{data?.settlement_date ? "resign"
                    : data?.employment_type === "full_time"
                      ? "permanent"
                      : data?.employment_type === "probationary"
                        ? "Probationary"
                        : data?.employment_type === "contractual"
                          ? "contractual" : "--"}</Text>
                </View>

                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text>{data?.branch_id
                    ? toCapitaliseStringType1(
                      branchList?.find((it) => it?.id === data?.branch_id)
                        ?.name || "--"
                    )
                    : "--"}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >

                  <Text>{data?.present_address ? data?.present_address : '--'}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "7%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >

                  <Text>{data?.guardian_name ? data?.guardian_name : "--"}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "center",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >

                  <Text>{data?.salary_type ? data?.salary_type : '--'}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >

                  <Text>{data?.esic_insurance_number ? data?.esic_insurance_number : "--"}</Text>
                </View>
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >

                  <Text>{data?.uan_no ? data?.uan_no : "--"}</Text>
                </View>
                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >

                  <Text>----</Text>
                </View> */}
                <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >

                  <Text> {data?.salary_info?.gross_salary ? data?.salary_info?.gross_salary : "--"}</Text>

                </View>
                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                      borderRight: "1px solid #000",
                    },
                  ]}
                >
                  <Text>----</Text>
                </View> */}

                {/* <View
                  style={[
                    reportStyles.ReportTdCell,
                    {
                      width: "5%",
                      textAlign: "right",
                    },
                  ]}
                >
                  <Text>----</Text>
                </View> */}
              </View>
            </>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default EmployeeExportPDF;